(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualPIIRegenerarService', ReporteEvaluativoVirtualPIIRegenerarService);

    ReporteEvaluativoVirtualPIIRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualPIIRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteVirtualPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteVirtualPIIregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
